<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QTVQZo/tc-custom/9781633535459.jpg?1740639095256" alt="This image is the cover for the book Real Life Organizing, Clutterbug"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Real Life Organizing, Clutterbug
      </h1>
      <p class="bookDescription body article font2">
        <b>The HGTV host’s bestselling guide to creating a Pinterest-worthy home in just fifteen minutes a day—and on a budget.</b>Organizational expert Cassandra ‘Cas’ Aarssen, the guru from YouTube’s ClutterBug channel, reveals her tips, tricks and secrets to a clean and clutter-free home in just fifteen minutes a day. Cas spends her time organizing other people’s homes, teaching college workshops on organization, and creating weekly videos and blog posts. In this book, she walks you through the steps to creating a beautiful, storage-smart, clutter free, and (almost!) self-cleaning home.  You don’t have to get rid of all of your things, be a yoga loving minimalist, or radically change your lifestyle or personality. The truth is you don’t need to actually be an organized person to live like an organized person—former slob Cas is proof of that. After you’ve read <i>Real Life Organizing</i>, you too will be able to live a more organized life without having to give up your sanity. Learn how to:  Create a Household Management Binder  Make a “Kids Cupboard” in your kitchen  Create an IN/OUT system  Organize paperwork based on your unique style  Carry out a painless purge  Create a Kitchen Command Center  Organize your holidays with a gift closet  Build a great toy organizing system  Stop wasting time hunting for lost items, and more 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cassandra Aarssen, Peter Walsh
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4dec75c